module.exports = "<div [class.active]=\"active\"> <p [attr.id]=\"faqId\" class=\"faq-body\" [innerHTML]=\"answer | safeHtml\"></p> </div> ";